'use client';

import React from 'react';
import { formatDayAbbr } from 'src/utils/formatDayAbbr/formatDayAbbr';

const getDayBgColor = (percentage: number): string => {
  if (percentage === 0) return 'bg-slate-200';
  if (percentage <= 20) return 'bg-green-100';
  if (percentage <= 40) return 'bg-green-500';
  if (percentage <= 60) return 'bg-green-700';
  return 'bg-green-800';
};

const getDayTextColor = (percentage: number): string => {
  if (percentage === 0) return 'text-disabled';
  if (percentage <= 20) return 'text-green-800';
  if (percentage <= 40) return 'text-green-100';
  if (percentage <= 60) return 'text-green-200';
  return 'text-green-100';
};

export interface DaySchedule {
  percentage: number;
  claims: number;
}

const CompactSchedule: React.FC<{
  schedule: Record<string, DaySchedule>;
}> = ({ schedule }) => {
  return (
    <div className="bg-neutral-100 p-4 pb-2" data-testid="compact-schedule">
      <div className="flex items-center gap-2">
        <div className="font-semibold ">Visit Planner</div>
      </div>
      <div className="text-xs text-neutral-500">
        Choose the best days to visit this location based on physician activity.
      </div>
      <div className="grid grid-cols-7 gap-4 pt-2" aria-label="Weekly schedule">
        {Object.entries(schedule).map(([day]) => {
          const dayData = schedule[day];
          const percentageValue = dayData?.percentage ?? 0;
          const formattedDay = formatDayAbbr(day);
          return (
            <div key={`${percentageValue}-${formattedDay}`}>
              <div className="flex flex-col items-center p-0">
                <div
                  className={`flex justify-center w-full max-w-16 py-1 rounded-lg ${getDayBgColor(
                    percentageValue
                  )}`}
                  title={`${formattedDay}: ${percentageValue}%`}
                >
                  <p
                    className={`text-sm font-medium ${getDayTextColor(
                      percentageValue
                    )}`}
                  >
                    {formattedDay}
                  </p>
                </div>
                <span className="text-sm py-2 text-neutral-800">
                  {percentageValue}%
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CompactSchedule;
